import { gql } from 'graphql-request'

import { IMAGE_FIELDS, META_INFORMATION } from '../utils/fragments'

export const ourTeamPageQuery = gql`
  {
    teamOverview(id: "55Rwgc8r9VdZgSsl1QzPTP") {
        metaInformation {
       ${META_INFORMATION}
        }
        icon {
            ${IMAGE_FIELDS}
        }
        title
        filtersCollection {
            items {
                teamName
            }
        }
        ctaCard {
            title
            description
            buttonText
            buttonPath
        }
    }
}
`

export const ourTeamEmployees = (
  searchQuery: string,
  skip: number,
  limit: number,
  filters: string[]
) => {
  const partOfTeamString = (filter: string) =>
    `{ partOfTeams: { teamName: "${filter}" } }`

  const mappedFilters = filters.map(partOfTeamString)
  const noFilters = partOfTeamString('')
  const teamFilters = mappedFilters.length > 0 ? mappedFilters : noFilters

  return gql`
    {
      employeeCollection(order: name_ASC, limit: ${limit}, skip: ${skip}, where: {
        AND: [{
            name_contains: "${searchQuery}",
            OR: [${teamFilters}]
          }]
        }
      ) {
        total
        items {
          professionalImage {
            ${IMAGE_FIELDS}
          }
          playfulImage {
            ${IMAGE_FIELDS}
          }
          name
          position
          phoneNumber
          emailAddress
          linkedinLink
          partOfTeamsCollection {
            items {
              teamName
          }
        }
      }
    }
  }`
}
